export default "__VITE_ASSET__Czv2w1hA__"